export default __webpack_public_path__ + "static/media/9.3c1407d5.jpg";